// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductOperation_container__h3bxF","icon-container":"ProductOperation_icon-container__YKgvK"};